export default "__VITE_PUBLIC_ASSET__1fff3250__"